import { Modal } from '@mui/material'
import { Box } from '@mui/system'
import React, { ReactNode } from 'react'

interface CustomModalProps {
    openState: boolean
    onCloseHandler: () => void
    children: ReactNode
    canBeCancelled?: boolean;
}

export const CustomModal: React.FC<CustomModalProps> = ({
    openState,
    onCloseHandler,
    children,
    canBeCancelled,
}) => {

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {xs: '90%', sm: '70%', md: '50%'},
        bgcolor: 'white',
        border: '2px solid',
        borderRadius: 4,
        boxShadow: 10,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 3,
        maxHeight: '90%',
        overflowY: 'auto'
    }

    return (
        <Modal
            open={openState}
            onClose={onCloseHandler}
        >
            <Box sx={modalStyle}>

                {children}

            </Box>



        </Modal>
    )
}
